import React, { Component } from "react";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import Loading from "../../../common/components/loading/loading";
import DualListBox from "../../../common/components/form/dualListBox";
import { withTranslation } from "react-i18next";
import {
  getProductQualityAttributeCandidates,
  getProductQualityAttributesByProduct,
  assignProductQualityAttribute,
  revokeProductQualityAttribute,
} from "../../../common/services/products/productQualityAttributeService";

class ProductQualityAttributes extends Component {
  state = {
    options: [],
    selected: [],
    isLoading: true,
  };

  async componentDidMount() {
    const { productId } = this.props;
    const allQualityAttributes = await getProductQualityAttributeCandidates(
      productId
    );
    const productQualityAttributes = await getProductQualityAttributesByProduct(
      productId
    );

    this.setState({
      options: this.mapToOptionsViewModel(allQualityAttributes),
      selected: this.mapToSelectedViewModel(productQualityAttributes),
      isLoading: false,
    });
  }

  mapToOptionsViewModel(productQualityAttributes) {
    return productQualityAttributes.map((qualityAttribute) => ({
      value: qualityAttribute.qualityAttributeId,
      label: qualityAttribute.name,
    }));
  }

  mapToSelectedViewModel(productQualityAttributes) {
    return productQualityAttributes.map(
      (qualityAttribute) => qualityAttribute.qualityAttributeId
    );
  }

  async handleChange(selected, selection, controlKey) {
    const { productId } = this.props;
    const eventId = uuid();

    if (controlKey !== "available" && controlKey !== "selected") {
      toast.warning(this.props.t("UnexpectedError"));
      return null;
    }

    // set the initial state,will clean up at the end if there are failures.
    this.setState({ selected: selected });

    for (const qualityAttributeId of selection) {
      if (controlKey === "available") {
        try {
          await assignProductQualityAttribute({
            qualityAttributeId: qualityAttributeId,
            productId: productId,
            isPriceDriver: false,
            active: true,
            eventId: eventId,
          });
          toast.success(this.props.t("QualityAttributeAdded"));
        } catch (ex) {
          console.log(ex);
          var index = selected.indexOf(qualityAttributeId);
          delete selected[index];
          toast.warning(this.props.t("QualityAttributeAdditionFailed"));
        }
      } else if (controlKey === "selected") {
        try {
          await revokeProductQualityAttribute(productId, qualityAttributeId);
          toast.success(this.props.t("QualityAttributeRevoked"));
        } catch (ex) {
          console.log(ex);
          selected.push(qualityAttributeId);
          toast.warning(this.props.t("QualityAttributeRevocationFailed"));
        }
      }
    }

    //Clean up with the actual outcome state
    this.setState({ selected: selected });
  }

  render() {
    const { options, selected, isLoading } = this.state;
    const { allowEdit } = this.props;

    if (isLoading) return <Loading />;

    return (
      <div>
        <DualListBox
          canFilter
          className="rdl-hide-move-all"
          disabled={!allowEdit}
          options={options}
          selected={selected}
          onChange={(selected, selection, controlKey) =>
            this.handleChange(selected, selection, controlKey)
          }
        />
      </div>
    );
  }
}

export default withTranslation(["products"])(ProductQualityAttributes);
